import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomHttp } from '../shared/custom.http';

import 'rxjs/add/operator/toPromise';

import { DPAccount } from './dp-account';
import { ApiConstants } from '../shared/api.constants';


@Injectable()
export class DPAccountService {

    private accountUrl = '/demandportal/account';  // URL to web api

    constructor(private router: Router, private http: CustomHttp, private apiConstants: ApiConstants) { }


    getAccountsByCompanyId(customer_id: number) {
        return this.http.get(this.apiConstants.getAccountByCustomerUrl(customer_id), {body: ''});
    }

    getAllAccounts() {
        return this.http.get(this.apiConstants.ENDPOINT_HELPDESK_ALL_ACCOUNT, {body: ''});
    }

    getAccount(account_id: number) {
        return this.http.get(this.apiConstants.getAccountByIdUrl(account_id), {body: ''});
    }

    deleteAccount(account: DPAccount) {
        return this.http.delete(this.apiConstants.getAccountByIdUrl(account.account_id), {body: ''});
    }

    // Add new User
    createAccount(account: DPAccount): Promise<DPAccount> {
        return this.http.post(this.apiConstants.getAccountByCustomerUrl(account.customer.customer_id), JSON.stringify(account));
    }

    // Update existing user
    updateAccount(account: DPAccount) {
        return this.http.put(this.apiConstants.getAccountByIdUrl(account.account_id), JSON.stringify(account));
    }

    getSubscriptionUserAccounts(){
        return this.http.get(this.apiConstants.getSubscriptionCustomersUrl(), {});
    }
    getSubscriptionsByAccount(accountId: number, fields : string){
        return this.http.get(`${this.apiConstants.getSubscriptionsByAccountUrl(accountId)}?fields=${fields}`, {});
    }

    getUserSetting( type ) {
      return this.http.get(this.apiConstants.getUserSettingUrl(type), {});
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-accounts.service.ts